import {
  SimulateCustomPresetVerification,
  SimulatePresetVerificationAttributes,
} from 'dashboard/models/simulate/preset';

export const vtvApiTypePresetToVerificationType = (vtvType: string) => {
  // e.g. Converts 'verification-template-version/government-id' to 'government_id'
  return vtvType.replace(/verification-template-version\//, '').replace(/-/g, '_');
};

export const getDefaultPreset = (
  customPresets: SimulateCustomPresetVerification[],
  examplePresets: SimulatePresetVerificationAttributes[],
) => {
  return customPresets?.[0]
    ? { ...customPresets[0].attributes, id: customPresets[0].id }
    : examplePresets[0];
};
